export default "__VITE_ASSET__Dpb8gClL__"